var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandSquaredLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5909 1.5H3.40909C2.35432 1.5 1.5 2.35432 1.5 3.40909V20.5909C1.5 21.6457 2.35432 22.5 3.40909 22.5H20.5909C21.6457 22.5 22.5 21.6457 22.5 20.5909V3.40909C22.5 2.35432 21.6457 1.5 20.5909 1.5ZM8.13791 18.6818H5.322V9.62127H8.13791V18.6818ZM6.70132 8.32595C5.79355 8.32595 5.0595 7.59 5.0595 6.68414C5.0595 5.77827 5.7945 5.04327 6.70132 5.04327C7.60623 5.04327 8.34218 5.77923 8.34218 6.68414C8.34218 7.59 7.60623 8.32595 6.70132 8.32595ZM18.6856 18.6818H15.8716V14.2756C15.8716 13.2247 15.8525 11.873 14.4083 11.873C12.9431 11.873 12.7178 13.0175 12.7178 14.1993V18.6818H9.90382V9.62127H12.6052V10.8593H12.6434C13.0195 10.1472 13.9377 9.396 15.3075 9.396C18.1587 9.396 18.6856 11.2726 18.6856 13.7125V18.6818Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandSquaredLinkedin);
export default __webpack_public_path__ + "static/media/brand_squared_linkedin.37abc1385f4c72d9cb12aedbd69947d1.svg";
export { ForwardRef as ReactComponent };